import { render, staticRenderFns } from "./DialogAlertDesempregado.vue?vue&type=template&id=21a6eb92&scoped=true"
import script from "./DialogAlertDesempregado.vue?vue&type=script&lang=ts"
export * from "./DialogAlertDesempregado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6eb92",
  null
  
)

export default component.exports